import { StatusTone } from 'src/shared/status-badge/status-badge.component';
import { OverloadMemoCertificationStatus, OverloadMemoStatus } from './overload-memo.model';

// Single source of truth for how a บันทึกข้อความ ภาระงานเกิน status is shown.
// Three pages used to each carry their own label + colour switch, which is how
// revision_requested read "ตีกลับแก้ไข" on one page and "ส่งกลับแก้ไข" on
// another. Labels mirror OverloadMemo::STATUS_LABELS on the backend, so they
// agree with the `status_label` the API sends. Pair with <app-status-badge>.
export interface OverloadMemoStatusDisplay {
  label: string;
  tone: StatusTone;
}

const DISPLAY_BY_STATUS: Record<OverloadMemoStatus, OverloadMemoStatusDisplay> = {
  draft: { label: 'แบบร่าง', tone: 'draft' },
  pending_education_head: { label: 'รอหัวหน้างานการศึกษารับรอง', tone: 'pending' },
  pending_vice_dean: { label: 'รอรองคณบดีรับรอง', tone: 'waiting_review' },
  certified: { label: 'รับรองแล้ว', tone: 'completed' },
  revision_requested: { label: 'ส่งกลับแก้ไข', tone: 'revision' },
};

// `notIssuedLabel` covers the surface (disbursement registry) where "no memo
// exists yet" is a real state rather than a draft record.
export function getOverloadMemoStatusDisplay(
  status: OverloadMemoStatus | null | undefined,
  notIssuedLabel?: string,
): OverloadMemoStatusDisplay {
  if (status == null) {
    return { label: notIssuedLabel ?? DISPLAY_BY_STATUS.draft.label, tone: 'draft' };
  }

  return DISPLAY_BY_STATUS[status];
}

const CERTIFICATION_DISPLAY: Record<OverloadMemoCertificationStatus, OverloadMemoStatusDisplay> = {
  pending: { label: 'รอรับรอง', tone: 'pending' },
  certified: { label: 'รับรองแล้ว', tone: 'completed' },
  rejected: { label: 'ส่งกลับแก้ไข', tone: 'revision' },
};

export function getOverloadMemoCertificationDisplay(
  status: OverloadMemoCertificationStatus | null | undefined,
): OverloadMemoStatusDisplay {
  return status == null ? CERTIFICATION_DISPLAY.pending : CERTIFICATION_DISPLAY[status];
}
